import React from 'react';
import { motion } from 'framer-motion';
import { FaCheckCircle } from 'react-icons/fa';
import DeleteButton from '../editors/DeleteButton';

interface Service {
  id: number;
  titleAr: string;
  titleEn: string;
  descriptionAr: string;
  descriptionEn: string;
  featuresAr: string[];
  featuresEn: string[];
  image: string;
}

interface ServicesGridSectionProps {
  language?: 'ar' | 'en';
  services?: Service[];
  onDeleteService?: (index: number) => void;
}

const ServicesGridSection: React.FC<ServicesGridSectionProps> = ({
  language = 'ar',
  services = [],
  onDeleteService
}) => {
  const isRTL = language === 'ar';

  return (
    <section className="section-padding">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12">
          {services.map((service, index) => (
            <motion.div
              key={service.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.8 }}
              viewport={{ once: true }}
              className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              {onDeleteService && (
                <DeleteButton onDelete={() => onDeleteService(index)} />
              )}
              
              {/* Service Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={isRTL ? service.titleAr : service.titleEn}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              </div>

              {/* Service Content */}
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {isRTL ? service.titleAr : service.titleEn}
                </h3>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {isRTL ? service.descriptionAr : service.descriptionEn}
                </p>

                {/* Features List */}
                <div className="space-y-3">
                  {(isRTL ? service.featuresAr : service.featuresEn).map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-center space-x-3 rtl:space-x-reverse">
                      <FaCheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" />
                      <span className="text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>


              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesGridSection; 